import React from 'react';

import { Box, Tab, Tabs } from '@mui/material';

import HealthRecordCategory from './HealthRecordCategory';
import HealthRecordDaily from './HealthRecordDaily';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

import Title from '@/components/Title';

/**
 * プロパティ
 */
export type Props = {
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
};

const HealthRecord: React.FC<Props> = ({
  user,
  child,
  facilityList,
}) => {
  const [tabIndex, setTabIndex] = React.useState(0);
  const tabs = ['日毎表示', '項目別表示'];
  return (
    <div>
      <Title title={`健康記録 - ${tabs[tabIndex]}`} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '10px' }}>
        <Tabs
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          value={tabIndex}
          onChange={(_event: React.SyntheticEvent, index: number) => {
            setTabIndex(index);
          }}
        >
          {tabs.map((label) => (
            <Tab label={label} key={label} />
          ))}
        </Tabs>
      </Box>
      {tabIndex === 0 && (
        <HealthRecordDaily child={child} user={user} facilityList={facilityList} />
      )}
      {tabIndex === 1 && (
        <HealthRecordCategory child={child} user={user} facilityList={facilityList} />
      )}
    </div>
  );
};

export default HealthRecord;
